import { Outlet } from "react-router-dom";
import { ToastProvider } from "../ui/Toast";
import { BottomTabs } from "./BottomTabs";

/**
 * El armazón de la aplicación: lo que rodea a todas las pantallas menos a *Acceso*.
 *
 * QUÉ APORTA
 *   La barra de pestañas fija y el sitio donde se posan los toasts. El ancho máximo y el hueco
 *   de las pestañas los pone `Page`, que es quien conoce la cabecera de cada pantalla.
 *
 * POR QUÉ *ACCESO* SE QUEDA FUERA
 *   Sin sesión no hay a dónde ir: unas pestañas que no llevan a ningún sitio son una promesa
 *   falsa. La ruta `/login` cuelga del router por su cuenta.
 */
export function AppShell() {
  return (
    <ToastProvider>
      <div className="min-h-screen bg-paper text-ink">
        <Outlet />
        <BottomTabs />
      </div>
    </ToastProvider>
  );
}
